module.exports = __webpack_public_path__ + "assets/img/analysisRole1.92c25fb0.png";